export default [
    {
        path: '/printSheetTeacher',
        name: 'printSheetTeacher',
        component: () => import ('./pages/Index')
    },
]